import React from 'react';
import { TabTypeTokens, } from '@voltmoney/schema';
import Typography from '../typography/Typography';
import Stack from '../stack/Stack';
export const args = {
    options: [
        { label: 'Tab 1' },
        { label: 'Tab 2' },
    ],
    components: [
        React.createElement(Stack, null,
            React.createElement(Typography, { label: 'Pending' }),
            ","),
        React.createElement(Stack, null,
            React.createElement(Typography, { label: 'In Progress' }),
            ","),
    ],
    widgetItems: [],
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(TabTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
};
